import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import APIS from "../../constant/Endpoint";
import SettingIcon from "../../Icons/SettingIcon";
import { createSubjectValidationForm } from "../../utils/validationSchemas";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import Modal from "../Reusable/Modal";
import SwitchButton from "../Reusable/SwitchButton";
import TableActionButton from "../Reusable/TableActionButton";
import FormBuilder from "./FormBuilder";

const CreateSubject = (props: any) => {
  const { handleCreate, isPostLoading, handleIsActive } = props;
  const [isOpenFormPopup, setIsOpenFormPopup] = useState(false);
  const [selected, setSelected] = useState(null);
  const {
    handleSubmit,
    register,
    setError,
    control,
    reset,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(createSubjectValidationForm),
  });

  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "title",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <AccessControl
          children={
            <SwitchButton
              id={row?.original?.id}
              value={getValue()}
              disabled={false}
              onChange={handleIsActive}
            />
          }
          allowedPermissions={["can_update_setting"]}
          renderNoAccess={
            <SwitchButton
              id={row?.original?.id}
              value={getValue()}
              disabled={true}
              onChange={handleIsActive}
            />
          }
        />
      ),
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <div className={tw`grid grid-cols-2 gap-x-2 items-center`}>
            <TableActionButton editPath={`/edit/${getValue()}`} />
            <button
              className={tw`focus:outline-none`}
              onClick={() => {
                setIsOpenFormPopup(!isOpenFormPopup);
                setSelected(getValue());
              }}
            >
              <SettingIcon color={"var(--primary)"} />
            </button>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <Card title="Add Subject">
        <form
          onSubmit={handleSubmit((data: any) =>
            handleCreate(data, reset, setError)
          )}
        >
          <TextField
            label={"Title"}
            register={register("title")}
            errors={errors?.title}
          />
          <div className={tw`w-full flex justify-end `}>
            <div className={tw`w-32`}>
              <Button label={"Create"} isLoading={isPostLoading} />
            </div>
          </div>
        </form>
      </Card>
      <DataTable
        url={APIS.SUBJECT}
        queryKey={"subject"}
        columns={defaultColumns}
        addNewPagePath={""}
        tableName={"Subject"}
        isUpload={false}
      />
      <Modal
        title="Form Builder"
        isOpen={isOpenFormPopup}
        setIsOpen={setIsOpenFormPopup}
      >
        <FormBuilder id={selected} setIsOpen={setIsOpenFormPopup} />
      </Modal>
    </>
  );
};

export default CreateSubject;
